import { create } from 'zustand'
import type { Agent } from '@/types'

interface AgentStore {
  agent: Agent | null
  setAgent: (agent: Agent | null) => void
  updateAgent: (updates: Partial<Agent>) => void
  clearAgent: () => void
}

export function useAgentStore(): AgentStore {
  return create<AgentStore>((set) => ({
    agent: null,
    setAgent: (agent) => set({ agent }),
    updateAgent: (updates) =>
      set((state) => ({
        agent: state.agent ? { ...state.agent, ...updates } : null,
      })),
    clearAgent: () => set({ agent: null }),
  }))
}
